import { Flex } from 'antd';

import { RingRangeSelection } from 'business/quality-control/pages/record-segment-defect/components/right-panel/range-selection';
import { RingDetails } from 'business/quality-control/pages/record-segment-defect/components/right-panel/ring-details';

import styles from './index.module.scss';

interface RightPanelProps {
  numberOfRings: number;
  selectedRing: string | null;
  setSelectedRing: (ringId: string | null) => void;
}

export const RightPanel = ({
  numberOfRings,
  selectedRing,
  setSelectedRing,
}: RightPanelProps) => {
  return (
    <Flex vertical align="center" className={styles.rightPanel}>
      {numberOfRings === 0 ? (
        <RingRangeSelection resetSelectedRing={() => setSelectedRing(null)} />
      ) : (
        <div style={{ width: '100%' }}>
          <RingDetails
            selectedRing={selectedRing ?? ''}
            setSelectedRing={setSelectedRing}
          />
        </div>
      )}
    </Flex>
  );
};
